<template>
  <div class="ewmUrl">
    <div :class="isShowMe?'orderDetails':'orderDetails hide'">
      <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
      <div class="detailList">
        <div class="dl-top">
          <div class="dl-title fl">更换群二维码</div>
          <div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
        </div>
        <div class="main">
           <el-upload
                    class="avatar-uploader"
                    ref="upload"
                    :action="domain"
                    accept="image/jpeg,image/gif,image/png,image/bmp"
                    :headers="myHeader"
                    :http-request="uploadFile"
                    :on-change="changeFile"
                    :show-file-list="false"
                    :auto-upload="false"
                    list-type="picture"
                    :multiple="false">
                    <img v-if="BinaryImg" :src="BinaryImg" class="avatar" >
                    <i v-else class="el-icon-plus avatar-uploader-icon"><span>选择图片</span></i>
            </el-upload> 
        </div>

        <div class="dl-footer">
             <el-row  align="middle"  type="flex" class="mb20"> 
              <el-col :span="14"><div class="grid-content bg-purple"></div></el-col>
              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-button type="primary" size="small" @click="closeWindow">取消</el-button>
                  <el-button type="primary" size="small" @click="editEwm">更换</el-button>
                </div>
              </el-col>
            </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ewmUrl',
  props:{
    isShow:Boolean,
    SerialNo:String
  },
  data () {
    return {
      isShowMe:this.isShow,
      BinaryImg:'',
      fileUid:0,
    }
  },
  computed:{
    domain(){
       return this.$store.getters.domain+'ImgBase64Upload1';
    },
    myHeader(){
      return {"content-type":"multipart/form-data"}
    },
     loading(){
       return this.$store.getters.loadingPara;
     }
  },
  methods: {
   closeWindow(){
			this.isShowMe=false;
   },
   changeFile(file,fileList){
       this.fileUid=file.uid;
       this.BinaryImg=file.url;
   },
   checkUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isGIF = file.type === 'image/gif';
        const isPNG = file.type === 'image/png';
        const isBMP = file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isGIF && !isPNG && !isBMP) {
            this.$alert('上传图片必须是JPG/GIF/PNG/BMP 格式!', '提示', {confirmButtonText: '确定'});
        }else if(!isLt2M) {
            this.$alert('上传图片大小不能超过 2MB!', '提示', {confirmButtonText: '确定'});
        }
        return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
   },
   uploadFile: function (fileObj) {     //上传图片成功后发布订单
       const loading = this.$loading(this.loading);
       var file=fileObj.file;
       if(file.uid==this.fileUid){
       var b=this.checkUpload(file);
       if(b){
            const self = this;
            var reader = new FileReader();
            reader.onload = function(event) {
            // event.target.result 即为图片的Base64编码字符串
            var imsJson = [{
              "value": event.target.result,
              "name":'111'
            }];
            var json={"file":imsJson,"SerialNo":self.SerialNo}
            self.http.ajaxPost('ImgBase64Upload2',json,"",function(data){
                loading.close();
                self.$alert(data.Message, '提示', {confirmButtonText: '确定'});
                if(data.ReturnCode==1){
                  self.closeWindow();
                }
            },function(res){ self.$alert(res, '错误', {confirmButtonText: '确定'});});
          }
          reader.readAsDataURL(file);
        }
      }
    },
    editEwm(){
      this.$refs.upload.submit();
    },
    GetEwmUrl(){
      const self=this;
      var data= this.common.GetlocalStorage("UnLockUserData");
      var obj=JSON.parse(data);
      var userId=obj.UserID;
      self.http.ajaxGet("GetEwmUrl?UserID="+userId+"&SerialNo="+self.SerialNo,function(res){
          self.BinaryImg=res.Result;
        },function(err){
          self.$alert(err, '错误', {confirmButtonText: '确定'});
      })
    }
  },
  watch: {
    isShow(val) {
      this.isShowMe = val;
    },
    isShowMe(val){
      if(val){
        this.GetEwmUrl();
      }else{
        this.$emit("on-close",val);
      }
    }
  },
  mounted: function () {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ewmUrl .detailList-bg{position:fixed;width:100%;height:100%;bottom:0;left:0; background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:999; }
.ewmUrl	.detailList{width:385px;height:470px;position: fixed; top:50%; left:50%; margin-left:-192.5px; margin-top:-235px;  z-index:999; background: #fff; }
.ewmUrl	.detailList .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
.ewmUrl	.detailList .dl-title{ font-size:20px; color:#444; margin-left:45px;}
.ewmUrl	.detailList .dl-close{ margin-right:25px; margin-top:8px;}
.ewmUrl	.detailList .dl-close img{ cursor: pointer;}
.ewmUrl  .detailList .dl-footer{height:60px; line-height:60px; font-size:16px; color:#444; background: #eee; position:absolute; bottom:0; width:325px; padding:0 30px;}
.ewmUrl  .detailList .main{ padding:30px 50px; font-size:16px; color:#444;}
.ewmUrl  .mb20{margin-bottom:20px;}
.ewmUrl  .avatar-uploader{cursor:pointer;overflow:hidden; float: left; vertical-align: bottom;}
.ewmUrl  .avatar-uploader-icon:hover {border-color:#409EFF;}
.ewmUrl  .avatar-uploader-icon {font-size:38px;color:#8c939d;width:128px;height:98px;text-align:center;border:1px dashed #d9d9d9;border-radius:6px; padding-top:30px;}
.ewmUrl  .avatar-uploader-icon span{ font-size:16px; display: block; padding-top:10px;}
.ewmUrl  .avatar{ max-width: 228px; max-height:228px;}
</style>



// WEBPACK FOOTER //
// src/components/ewm.vue